import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-tablet",
  templateUrl: "./med-icon-tablet.component.html",
})
export class MedIconTabletComponent extends SvgMixinComponent {}
